import React from 'react';

const sel = 'h-9 rounded-md bg-[#0A0A0A] border border-[#262626] text-white text-sm px-2 max-w-[200px]';

// Trade chips come from the canonical Departments list (type=trade only — Office/Internal never shows).
export const TradeFilterChips = ({ trades, value, onChange, counts = {} }) => {
  const chips = [{ key: '', label: 'All Trades', count: counts.__all__ },
    ...trades.map((t) => ({ key: t.name, label: t.name, count: counts[t.name] })),
    { key: '__none__', label: 'No Trade', count: counts.__none__ }];
  return (
    <div data-testid="inv-trade-filter" className="flex flex-wrap gap-2">
      {chips.map((c) => (
        <button key={c.key || 'all'} type="button" data-testid={`inv-trade-chip-${c.key === '__none__' ? 'no-trade' : c.key ? c.key.replace(/[^a-z0-9]+/gi, '-').toLowerCase() : 'all'}`}
          onClick={() => onChange(c.key)}
          className={`px-3 h-8 rounded-full text-xs font-semibold border transition-colors ${value === c.key
            ? 'bg-[#D4AF37] text-[#0A0A0A] border-[#D4AF37]' : 'border-[#262626] text-[#A3A3A3] hover:text-white hover:border-[#3f3f3f]'}`}>
          {c.label}{c.count !== undefined && <span className="ml-1.5 opacity-70">{c.count}</span>}
        </button>
      ))}
    </div>
  );
};

export const InventoryAttributeFilters = ({ f, set, categories, suppliers, brands }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="inv-attr-filters">
    <select data-testid="inv-filter-category" value={f.category} onChange={(e) => set({ category: e.target.value })} className={sel}>
      <option value="">All categories</option>
      <option value="__none__">No category</option>
      {[...new Set(categories.map((c) => c.name))].sort().map((n) => <option key={n} value={n}>{n}</option>)}
    </select>
    <select data-testid="inv-filter-supplier" value={f.supplier} onChange={(e) => set({ supplier: e.target.value })} className={sel}>
      <option value="">All suppliers</option>
      <option value="__none__">No supplier</option>
      {suppliers.map((s) => <option key={s.id} value={s.name}>{s.name}</option>)}
    </select>
    <select data-testid="inv-filter-brand" value={f.brand} onChange={(e) => set({ brand: e.target.value })} className={sel}>
      <option value="">All brands</option>
      {brands.map((b) => <option key={b.id} value={b.name}>{b.name}</option>)}
    </select>
    <select data-testid="inv-filter-status" value={f.status} onChange={(e) => set({ status: e.target.value })} className={sel}>
      <option value="active">Active</option>
      <option value="archived">Archived</option>
      <option value="all">Active + Archived</option>
    </select>
    <label className="flex items-center gap-2 text-white text-sm cursor-pointer">
      <input data-testid="inv-filter-low" type="checkbox" checked={f.low} onChange={(e) => set({ low: e.target.checked })} className="accent-[#D4AF37]" />
      <span title="Company Low Stock: Shop + Warehouse On Hand is below the item's Company Minimum. Vans never count.">Below company min</span>
    </label>
  </div>
);
